<div
  class="layout-widgets {{ headTranlateY === 0 ? 'widgets-show' : 'widgets-hide' }}"
  [style.z-index]="['home', 'MinigameComponent'].includes($any(lastPage)?._componentName ?? lastPage) ? '1' : '0'"
>
  <img src="{{ 'assets/images/activity/ny2024/c1.png' | preferWebp }}" alt="" />
</div>

<div class="layout-background">
  <img src="{{ 'assets/images/activity/euro2024/bg.jpg' | preferWebp }}" alt="" />
</div>

<div
  class="basic-layout"
  [class.left-side-invisible]="layout.leftMenuInvisible$ | async"
  [class.left-side-expand]="leftMenuState"
>
  <app-statistics-panel></app-statistics-panel>

  <div
    class="layout-backdrop-popup"
    [class.clickible]="leftMenuService.popupStatus"
    (click)="leftMenuService.popupStatus = false"
  ></div>
  <div class="layout-backdrop" [class.show]="leftMenuBackdrop" (click)="layout.leftMenuState$.next(false)"></div>
  <div class="left-side" [style.width]="leftMenuWidth" [class.hide]="conciseMode" [class.no-shadow]="noShadow">
    <app-left-menu></app-left-menu>
  </div>
  <div
    class="layout-content"
    [style.margin-left]="layoutContentMarginLeft"
    [style.margin-right]="layoutContentMarginRight"
  >
    <app-header
      [class.show-download]="active && isH5"
      [layoutContentMarginLeft]="layoutContentMarginLeft"
      [layoutContentMarginRight]="layoutContentMarginRight"
      [class]="headTranlateY === 0 ? 'header-hide' : 'header-show'"
      [style.transform]="'translateY(' + headTranlateY + '%)'"
    ></app-header>
    @if (hideLevel2Head && isH5) {
      <app-header-level2-menu
        #level2Menu
        [class.hide]="conciseMode"
        [layoutContentMarginLeft]="layoutContentMarginLeft"
        [layoutContentMarginRight]="layoutContentMarginRight"
        [class]="headTranlateY === 0 ? 'header-hide' : 'header-show'"
        [style.transform]="'translateY(' + (headTranlateY === 0 ? headTranlateY : headTranlateY - 150) + '%)'"
      ></app-header-level2-menu>
    }
    <div class="layout-main-content">
      <div
        class="layout-main-content-backdrop animate__animated animate__fadeIn animate__faster"
        *ngIf="isH5 && (layout.mainContentBackdrop$ | async)"
      ></div>
      <ng-container *ngIf="isDesktop">
        <app-scrollbar
          #scrollbar
          (scorllDistance)="onScrollDistance($event)"
          [disabled]="fullMode || !!(layout.lockLayoutScroll$ | async)"
        >
          <router-outlet></router-outlet>
          <app-footer *ngIf="!fullMode"></app-footer>
        </app-scrollbar>
      </ng-container>
      <!-- H5不用組件 -->
      <ng-container *ngIf="!isDesktop">
        <div
          class="content"
          [class.disabled]="fullMode || !!(layout.lockLayoutScroll$ | async)"
          (scroll)="onScrollOldIos($event)"
        >
          <router-outlet></router-outlet>
          <app-footer *ngIf="!fullMode"></app-footer>
        </div>
      </ng-container>
      <app-bottom-menu *ngIf="!fullMode"></app-bottom-menu>
    </div>
  </div>
</div>

<!-- 右侧 综合弹窗 -->
<div class="right-side" [style.width]="isOpenRightCombinePopup ? (isH5 ? '100vw' : '375px') : '0'">
  <app-right-combine-popup *ngIf="logined && isOpenRightCombinePopup"></app-right-combine-popup>
</div>
